import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form, Input, FormInstance } from 'antd';
import { FILTER_CONDITIONS } from '@bringg/types';

import { FilterContentSelect } from './filter-content-select';
import { Translations } from '../filter-bar-2';

interface Props {
	name: string;
	translations: Translations;
	form: FormInstance;
	onFilterChange: () => void;
}

export const FilterContentTextCondition = ({ name, translations, form, onFilterChange }: Props) => {
	const CONDITIONS = useMemo(() => {
		return [
			{
				value: FILTER_CONDITIONS.CONTAINS,
				label: translations.conditionFilter.options?.[FILTER_CONDITIONS.CONTAINS]
			},
			{
				value: FILTER_CONDITIONS.EQUALS,
				label: translations.conditionFilter.options?.[FILTER_CONDITIONS.EQUALS]
			},
			{
				value: FILTER_CONDITIONS.NOT_CONTAINS,
				label: translations.conditionFilter.options?.[FILTER_CONDITIONS.NOT_CONTAINS]
			},
			{
				value: FILTER_CONDITIONS.NOT_EQUALS,
				label: translations.conditionFilter.options?.[FILTER_CONDITIONS.NOT_EQUALS]
			},
			{
				value: FILTER_CONDITIONS.IS_EMPTY,
				label: translations.conditionFilter.options?.[FILTER_CONDITIONS.IS_EMPTY]
			},
			{
				value: FILTER_CONDITIONS.IS_NOT_EMPTY,
				label: translations.conditionFilter.options?.[FILTER_CONDITIONS.IS_NOT_EMPTY]
			}
		];
	}, [translations]);

	// TODO: should be done by Form.useWatch from next version of Antd pkg
	const [conditionType, setConditionType] = useState<FILTER_CONDITIONS>();

	// TODO: should be done by Form.useWatch from next version of Antd pkg
	const handleConditionTypeChange = useCallback((value: FILTER_CONDITIONS) => {
		setConditionType(value);
		onFilterChange();
	}, []);

	useEffect(() => {
		const formItemValue = form.getFieldValue(name);
		if (formItemValue) {
			form.setFieldsValue({
				[name]: Object.assign(formItemValue, { value: null })
			});
		}
	}, [conditionType]);

	const showFilterValueInput = useMemo(() => {
		return (
			!conditionType ||
			(conditionType !== FILTER_CONDITIONS.IS_EMPTY && conditionType !== FILTER_CONDITIONS.IS_NOT_EMPTY)
		);
	}, [conditionType]);

	return (
		<Form.Item name={name}>
			<Input.Group>
				<FilterContentSelect
					className="condition-filter-select"
					name={[name, 'condition']}
					values={CONDITIONS}
					placeholder={translations.conditionFilter.operatorSelectPlaceholder}
					multiselect={false}
					translations={translations}
					onChange={handleConditionTypeChange}
					form={form}
				/>
				{showFilterValueInput && (
					<Form.Item name={[name, 'value']}>
						<Input placeholder={translations.search} onChange={onFilterChange} />
					</Form.Item>
				)}
			</Input.Group>
		</Form.Item>
	);
};
